import { GET, POST } from '../annotations';
import { DEVICE_MANUFACTURER } from '../config';
import { ascii, uint32 } from '../converters';
import { VirtualTap } from '../virtual-tap-server';

export class DeviceService {
  constructor(public server: VirtualTap) {}

  @GET({
    path: '/3//0',
    responseType: ascii,
  })
  public getManufacturer() {
    return DEVICE_MANUFACTURER;
  }

  @GET({
    path: '/3//1',
    responseType: ascii,
  })
  public getFirmwareFlavor() {
    return this.server.modelName;
  }

  @GET({
    path: '/3//2',
    responseType: ascii,
  })
  public getSerialNumber() {
    return this.server.serialNumber;
  }

  @GET({
    path: '/3//3',
    responseType: ascii,
  })
  public getFirmwareVersion() {
    return this.server.firmwareVersion;
  }

  @POST({
    path: '/3//4',
    auth: ['admin'],
  })
  public reboot() {
    this.server.reboot();
  }

  @POST({
    path: '/3//5',
    auth: ['admin'],
  })
  public factoryReset() {
    this.server.factoryReset();
  }

  @GET({
    path: '/3//10',
    responseType: uint32,
  })
  public getMemoryFree() {
    return 0xffffffff;
  }

  @GET({
    path: '/3//11',
    responseType: uint32,
  })
  public getLastErrorCode() {
    return 0;
  }

  @GET({
    path: '/3//13',
    responseType: uint32,
  })
  public getCurrentTime() {
    return new Date().getTime() / 1000;
  }
}
